module.exports = __webpack_public_path__ + "img/TBWTTNL_benefits_age.feff1889.png";